import React, { useState } from "react";
import FooterTwo from "../../components/footer/FooterTwo";
import CopyRightTwo from "../../components/footer/CopyRightTwo";
import { Helmet } from "react-helmet";
import HeaderThree from "../../components/header/HeaderThree";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import axios from "axios";
import { API_URL } from "../../config";

const RequestQuote = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    country: "",
    projectDescription: "",
  });

  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});



  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };


  const handleSubmit = async (e) => {

    e.preventDefault();


    const formData = new FormData();
    Object.keys(form).forEach(key => formData.append(key, form[key]));
    if (file) formData.append("document", file);

    try {
      const res = await axios.post(`${API_URL}/api/request`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });


      alert("data sumitted succesfully")
      setMessage(res.data.message);
      console.log("Response:", res.data);
      setForm({ name: "", email: "", phoneNumber: "", country: "", projectDescription: "" });
      setFile(null);
      console.log("data submitted succesfully")
    }

    catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Error submitting application");
    }
  };

  return (
    <div className="main-page-wrapper">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />

      <div className="carrier-section">
        <div className="container">
          <div className="hero-section text-center">
            <h1 className="hero-title">Request a Quote</h1>
            <h2 className="hero-subtitle">
              Tell us about your business goals and we will contact you. Feel free to reach out for consultation or questions.
            </h2>
          </div>

          <div className="career-form-container">

            <form className="career-form" onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label className="form-label">Full Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-input"
                    placeholder="Enter your name"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    className="form-input"
                    placeholder="Enter your email address"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Phone Number</label>
                  <PhoneInput
                    country={"in"}
                    value={form.phoneNumber}
                    placeholder="Enter your phone number"
                    onChange={(value, data) =>
                      setForm((prev) => ({
                        ...prev,
                        phoneNumber: value,
                        country: data?.name || prev.country,
                      }))
                    }
                    inputStyle={{
                      height: "55px",
                      paddingLeft: "60px",
                    }}
                    inputClass={`form-input ${errors.phone ? "error" : ""}`}
                  />
                  {errors.phone && (
                    <div className="error-message">{errors.phone}</div>
                  )}
                </div>


                <div className="form-group">
                  <label className="form-label">Country</label>
                  <input
                    type="text"
                    name="country"
                    className="form-input"
                    placeholder="Enter your Country Name"
                    value={form.country}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group full-width">
                <label className="form-label">Project Description</label>
                <textarea
                  name="projectDescription"
                  className="form-input"
                  placeholder="Describe your project"
                  rows="4"
                  value={form.projectDescription}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <div className="file-upload-section">
                <div className="file-upload-content">
                  <div className="upload-icon">
                    <i className="fa fa-cloud-upload"></i>
                  </div>
                  <div className="upload-text">
                    <h3>Upload Your Document</h3>
                    <p>PDF, DOC, DOCX (Max size: 5MB)</p>
                  </div>
                  <input
                    type="file"
                    name="document"
                    className="file-input"
                    accept=".pdf,.doc,.docx"
                    onChange={handleFileChange}
                  />
                </div>
              </div>

              <div className="form-footer d-flex justify-content-center ">
                <button type="submit" className="submit-button btn-gradient">
                  Submit Application
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RequestQuote;
